import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Squad, SquadList as ApiSquadList, TeamListElement, TeamListMinimum } from "../../../../client/api";
import { getMainLeague } from "../../../../config/utils";
import client, { callClientFunc } from "../../../../client";
import { ClavaContext } from "../../../../config/contexts";
import useBoolState from "../../../../hooks/useBoolState";
import CreateEditPlayer from "../CreateEditPlayer";
import { IDType } from "../../../../config/types";
import SquadList from "../../../components/Team/SquadList";
import { useSquadListController } from "../../../components/Team/useSquadListController";

const SquadManagement: React.FC<{ team: TeamListMinimum | TeamListElement }> = ({ team }) => {
  const { l } = useContext(ClavaContext);
  const [squad, setSquad] = useState<ApiSquadList>();
  const [insert, toggleInsert, setInsert] = useBoolState(false);
  const [edit, setEdit] = useState<Squad>();
  const closeEditInsert = useCallback((newPlayer?: Squad | IDType) => {
    if (newPlayer) {
      if (typeof newPlayer === "number") {
        setSquad(s => s ? s.filter(sq => sq.player.id !== newPlayer) : s);
      } else {
        setSquad(s => {
          let found = false;
          if (s) {
            const mapped = s.map((sq) => {
              if (sq.player.id === newPlayer.player.id) {
                found = true;
                return newPlayer;
              }
              return sq;
            });
            if (!found) {
              return [newPlayer, ...mapped];
            }
            return mapped;
          }
          return [newPlayer];
        });
      }
    }
    setEdit(undefined);
    setInsert(false);
  }, [setInsert]);
  const [loading, setLoading] = useState(false);

  const mainLeague = useMemo(
    () => getMainLeague(team.leagues),
    [team]
  );
  useEffect(() => {
    setLoading(true);
    callClientFunc(client().getSquad, true, team.id).then((res) => {
      setSquad(res);
      setLoading(false);
    }, () => {
      setLoading(false);
    });
  }, [team.id]);
  const {
    sortDir,
    sortField,
    q,
    setQ,
    filteredSquad,
    onSortBirth,
    onSortGiven,
    onSortFamily,
    onSortPosition
  } = useSquadListController(squad, mainLeague, l);
  return (
    <>
      <div className="rounded-2xl border border-light-gray dark:border-light-gray-dark bg-bg dark:bg-bg-dark shadow-sm p-4">
        <SquadList
          squad={squad}
          filteredSquad={filteredSquad}
          leagueForPosition={mainLeague}
          loading={loading}
          q={q}
          onChangeQ={setQ}
          sortField={sortField}
          sortDir={sortDir}
          onSortGiven={onSortGiven}
          onSortFamily={onSortFamily}
          onSortBirth={onSortBirth}
          onSortPosition={onSortPosition}
          onEdit={(s) => setEdit(s)}
          onClickNew={toggleInsert}
          showNewButton
        />
      </div>
      {insert && (
        <CreateEditPlayer close={closeEditInsert} teamId={team.id} />
      )}
      {edit && (
        <CreateEditPlayer close={closeEditInsert} player={edit} teamId={team.id} />
      )}
    </>
  );
};

export default SquadManagement;
